var PRICE_ON_REQUEST_HULK_FORM_ID = '67Emy8GoHbzYDBFwNWtPIQ';
// The form's only field, labelled exactly as in Hulk Form Builder.
var PRICE_ON_REQUEST_HULK_FIELD_LABEL = 'Price Request Received';
// anushkakhanna's shop id in Hulk Form Builder (window.hulkFormBuilder.shop_data).
var PRICE_ON_REQUEST_HULK_SHOP_UUID = 'L3DRnOtfgUSdK0eRbzpS5Q';
var PRICE_ON_REQUEST_HULK_ENDPOINT = 'https://formbuilder.hulkapps.com/ajaxcall/formresponse';
var PRICE_ON_REQUEST_GEO_ENDPOINT = 'https://ipwho.is/';
// IP-only fallback for when the geo lookup fails (e.g. ipwho.is rate limit).
var PRICE_ON_REQUEST_IP_ENDPOINT = 'https://api.ipify.org?format=json';
var PRICE_ON_REQUEST_LOOKUP_TIMEOUT_MS = 4000;

document.addEventListener('click', function (event) {
  var button = event.target.closest('.price-on-request-button');
  if (!button) return;

  var title = button.getAttribute('data-product-title') || document.title;
  var url = button.getAttribute('data-product-url') || window.location.href;

  priceOnRequestFetchGeo().then(function (geo) {
    var ipPromise = geo && geo.ip ? Promise.resolve(geo.ip) : priceOnRequestFetchIp();

    return ipPromise.then(function (ip) {
      var ipText = ip || 'unknown';
      var locationParts = geo
        ? [geo.city, geo.region, geo.country].filter(Boolean)
        : [];
      var locationText = locationParts.length
        ? locationParts.join(', ')
        : 'location unavailable';

      var message =
        'A customer requested pricing for "' +
        title +
        '" and has been sent to WhatsApp. Product link: ' +
        url +
        '. IP: ' +
        ipText +
        ' (' +
        locationText +
        ')';

      submitHulkForm(message);
    });
  });
});

var priceOnRequestGeoPromise = null;
var priceOnRequestIpPromise = null;

function priceOnRequestFetchGeo() {
  if (priceOnRequestGeoPromise) return priceOnRequestGeoPromise;

  priceOnRequestGeoPromise = priceOnRequestFetchJson(PRICE_ON_REQUEST_GEO_ENDPOINT, 'Geo').then(
    function (data) {
      if (data && data.success === false) {
        console.warn('[price-on-request] Geo lookup unsuccessful.', data);
        return null;
      }
      return data;
    }
  );

  return priceOnRequestGeoPromise;
}

function priceOnRequestFetchIp() {
  if (priceOnRequestIpPromise) return priceOnRequestIpPromise;

  priceOnRequestIpPromise = priceOnRequestFetchJson(PRICE_ON_REQUEST_IP_ENDPOINT, 'IP').then(
    function (data) {
      return (data && data.ip) || null;
    }
  );

  return priceOnRequestIpPromise;
}

// Resolves with the parsed JSON, or null on error or timeout.
function priceOnRequestFetchJson(url, label) {
  return new Promise(function (resolve) {
    var settled = false;
    var timeoutId = setTimeout(function () {
      if (settled) return;
      settled = true;
      console.warn('[price-on-request] ' + label + ' lookup timed out.');
      resolve(null);
    }, PRICE_ON_REQUEST_LOOKUP_TIMEOUT_MS);

    fetch(url)
      .then(function (response) {
        return response.json();
      })
      .then(function (data) {
        if (settled) return;
        settled = true;
        clearTimeout(timeoutId);
        console.log('[price-on-request] ' + label + ' lookup resolved:', data);
        resolve(data);
      })
      .catch(function (error) {
        if (settled) return;
        settled = true;
        clearTimeout(timeoutId);
        console.warn('[price-on-request] ' + label + ' lookup failed.', error);
        resolve(null);
      });
  });
}

function priceOnRequestPrefetchGeo(event) {
  if (!event.target.closest('.price-on-request-button')) return;
  priceOnRequestFetchGeo();
}

document.addEventListener('pointerover', priceOnRequestPrefetchGeo);
document.addEventListener('touchstart', priceOnRequestPrefetchGeo, {
  passive: true,
});

// Sends the same request Hulk's own app embed sends when it renders a form
// on the page (hulkFBPostFormResponse in its extra-functions.js). Posting it
// directly avoids the hidden form, which Hulk now loads in a cross-origin
// iframe that the page can't fill in.
function submitHulkForm(message) {
  var formResponse = {};
  formResponse[PRICE_ON_REQUEST_HULK_FIELD_LABEL] = message;

  console.log('[price-on-request] Submitting Hulk form with message:', message);

  fetch(PRICE_ON_REQUEST_HULK_ENDPOINT, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'X-Shop-UUID': PRICE_ON_REQUEST_HULK_SHOP_UUID,
    },
    body: JSON.stringify({
      form_uuid: PRICE_ON_REQUEST_HULK_FORM_ID,
      formResponse: JSON.stringify(formResponse),
      confirmationMail: true,
      email_check: '',
      utm_params: null,
      referrer_url: null,
    }),
  })
    .then(function (response) {
      if (!response.ok) throw new Error('HTTP ' + response.status);
      return response.json();
    })
    .then(function (data) {
      console.log('[price-on-request] Hulk form submitted:', data);
    })
    .catch(function (error) {
      console.warn('[price-on-request] Hulk form submission failed.', error);
    });
}
